(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[695],{

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 87714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ exactSearch; }
/* harmony export */ });
var hasAtLeastNumbers = function(phrase) {
    var numbers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    var re = /\d/g;
    var repeats = ((phrase || "").match(re) || []).length;
    return repeats >= numbers;
};
var hashHyphens = function(phrase) {
    var indexOfHyphen = phrase.indexOf("-");
    return indexOfHyphen !== -1;
};
function exactSearch(phrase) {
    return hasAtLeastNumbers(phrase) || hashHyphens(phrase);
};


/***/ }),

/***/ 82768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCategoriesBrands; }
/* harmony export */ });
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query categoriesBrands($websiteId: ID) {\n        categories(websiteId: $websiteId) {\n          items {\n            _id\n            name\n            brand {\n              _id\n              name\n              link\n              menuImage {\n                _id\n                url: resizedURL(width: 1200, height: 240)\n              }\n              categoriesImage {\n                _id\n                url\n              }\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useCategoriesBrands(websiteId) {
    var categories = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        }
    }).categories;
    return categories;
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 12255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUrlSearch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62280);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17673);
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1003);





function useUrlSearch() {
    var ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _debounceTime = ref3.debounceTime, debounceTime = _debounceTime === void 0 ? 500 : _debounceTime;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), filterText = ref1[0], setFilter = ref1[1];
    var debouncedFilterArr = (0,_useDebounce__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(filterText, debounceTime);
    var ref2;
    var filter = (ref2 = debouncedFilterArr[0]) !== null && ref2 !== void 0 ? ref2 : null;
    // This useEffect takes care of loading the current category on page refresh or initial load
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref;
        var q = (ref = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router)) === null || ref === void 0 ? void 0 : ref.q;
        var qValue = Array.isArray(q) ? q[0] : q;
        if (qValue !== "" && filter !== qValue) {
            setFilter(qValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // We want to do this only on load
    ;
    // This useEffect takes care of updating the current URL to reflect the search input
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref;
        var query = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router);
        var q = (ref = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router)) === null || ref === void 0 ? void 0 : ref.q;
        var qValue = Array.isArray(q) ? q[0] : q;
        if (filter && qValue && qValue !== filter) {
            setFilter(qValue);
            var url = "".concat(window.location.pathname, "?").concat((0,querystring__WEBPACK_IMPORTED_MODULE_3__.stringify)(query));
            router.push(url, url, {
                scroll: false
            });
        } else if (filter) {
            query.q = filter;
        } else {
            delete query.q;
        }
    }, [
        filter,
        router
    ]);
    return {
        filter: filter,
        setFilter: setFilter,
        filterText: filterText
    };
};


/***/ }),

/***/ 61863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/helpers/misc/exactSearch.ts
var exactSearch = __webpack_require__(87714);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/CategoryPage/Content/TopRow/MobileCategoriesMenu/index.tsx
var MobileCategoriesMenu = __webpack_require__(30121);
// EXTERNAL MODULE: ./src/hooks/useCategoriesBrands.ts
var useCategoriesBrands = __webpack_require__(82768);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx + 1 modules
var Brands = __webpack_require__(51888);
;// CONCATENATED MODULE: ./src/page-components/Order/CategoriesLayout/Search/MultiBrandSearchBar/index.tsx





function MultiBrandSearchBar(props) {
    var scrollToCategory = props.scrollToCategory, setFilter = props.setFilter;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var categories = (0,useCategoriesBrands/* default */.Z)(websiteId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Brands/* default */.Z, {
        categories: categories === null || categories === void 0 ? void 0 : categories.items,
        scrollTo: function(category) {
            return scrollToCategory(category);
        },
        onClick: function() {
            return setFilter(null);
        }
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/CategoriesLayout/Search/styles.module.css
var styles_module = __webpack_require__(99220);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CategoriesLayout/Search/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











function Search(props) {
    var filter = props.filter, setFilter = props.setFilter, showCategories = props.showCategories, website = props.website, scrollToCategory = props.scrollToCategory;
    var input = (0,useRef/* useRef */.s)(null);
    var ref = _slicedToArray((0,useState/* useState */.e)(false), 2), open = ref[0], setOpen = ref[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order"
    }).t;
    var isExact = (0,exactSearch/* default */.Z)(filter || "");
    var ref1 = _slicedToArray((0,useState/* useState */.e)(true), 2), barBrand = ref1[0], setBarBrand = ref1[1];
    (0,react.useEffect)(function() {
        if (!barBrand) input.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, [
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCategoriesMenu/* default */.Z, {
                setOpen: setOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).inner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).search,
                            onClick: function() {
                                if (website.categoryLayoutForMultiBrand) setBarBrand(!barBrand);
                                if (!barBrand) input.current.focus();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdSearch */.vU7, {
                                size: 20
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: (website === null || website === void 0 ? void 0 : website.isMultiBrand) && (website === null || website === void 0 ? void 0 : website.categoryLayoutForMultiBrand) && barBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiBrandSearchBar, {
                                scrollToCategory: scrollToCategory,
                                setFilter: setFilter
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                ref: input,
                                className: (styles_module_default()).input,
                                value: isExact ? "" : filter || "",
                                onChange: function(event) {
                                    return setFilter(event.target.value || null);
                                },
                                type: "text",
                                placeholder: t("labelSearchProductCategory")
                            })
                        }),
                        filter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).close,
                            onClick: function() {
                                return setFilter(null);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                                size: 20
                            })
                        }) : null,
                        showCategories ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (styles_module_default()).textWithIcon,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdSort */.wlS, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            return setOpen(true);
                                        },
                                        className: (styles_module_default()).spaceLeft,
                                        children: t("labelShowCategories")
                                    })
                                ]
                            })
                        }) : null
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 30121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MobileCategoriesMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50456);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32533);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95420);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61524);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCategoriesForMenu($websiteId: ID) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        name\n        subCategories {\n          items {\n            _id\n            name\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var styles = _objectSpread({}, (_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default()), (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default()));
var query = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__["default"])(_templateObject());
function MobileCategoriesMenu(param) {
    var setOpen = param.setOpen;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), selected = ref4[0], setSelected = ref4[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var i18nGeneric = "generic:fields";
    var i18nWebsite = "website:order";
    var ref1 = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useApolloQuery */ .Zu)({
        query: query,
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }), categories = ref1.categories, loading = ref1.loading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("/pedir/category/")) {
            var ref2, ref3;
            var categoryIdSelected = (ref3 = (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.split("/")) === null || ref3 === void 0 ? void 0 : ref3.pop();
            setSelected(categories.items.find(function(category) {
                return category._id === categoryIdSelected;
            }));
        }
    }, [
        router,
        categories.items
    ]);
    if (loading || !categories) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.closeMenu,
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: t("".concat(i18nGeneric, ".close"))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.loadingContainer,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.closeMenu,
                onClick: function() {
                    return setOpen(false);
                },
                children: t("".concat(i18nGeneric, ".close"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.container,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.categories,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles.header,
                            children: [
                                selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: styles.textWithIcon,
                                    onClick: function() {
                                        return setSelected(null);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdKeyboardArrowLeft */ .sG8, {
                                        size: "22"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: styles.primaryColor,
                                        onClick: function() {
                                            setOpen(false);
                                            router.push("/pedir/category/".concat(selected._id));
                                        },
                                        children: selected.name
                                    }) : t("".concat(i18nWebsite, ".labelCategories"))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.categoriesList,
                            children: (selected ? selected.subCategories : categories).items.map(function(category, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: styles.categoryItem,
                                    onClick: function() {
                                        setOpen(false);
                                        router.push("/pedir/category/".concat(category._id));
                                        setSelected(category);
                                    },
                                    children: category.name
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 51888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/styles.module.css
var styles_module = __webpack_require__(9474);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/index.tsx




function BrandBar(props) {
    var imgSrc = get_default()(props, "brand.categoriesImage.url");
    return imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: (styles_module_default()).image,
        onClick: props.onClick,
        src: props.brand.categoriesImage.url
    }) : null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/styles.module.css
var Categories_styles_module = __webpack_require__(23568);
var Categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(Categories_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx




function Categories(props) {
    if (!props.categories) return null;
    var lastBrandId = null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).brandsContainer,
        children: props.categories.map(function(category) {
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar, {
                brand: brand,
                onClick: function() {
                    props.onClick();
                    props.scrollTo(category._id);
                }
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: brandContent
            }, category._id);
        })
    });
};


/***/ }),

/***/ 99220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YxiHSb7h4b5EYIynfWewC categoriesLayout_search_container backgroundColor backgroundBorderColor","inner":"nm5jzathPt4eCtHLhgnfo","search":"_1nSzvNSxn_EVuwYBPHJGjw","close":"_32mu-B87v_h0J7yr_dlgAW _1nSzvNSxn_EVuwYBPHJGjw","input":"_3IwRejILbKt1jhJsVNj15i backgroundColor textColor","textWithIcon":"_10TKCYQF6Y5nMQDiU21L92","spaceLeft":"F3Gka-nCO2g4EMVyHcvgR"};

/***/ }),

/***/ 95420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forceColor":"_1FzGGrusCYvYM-XueTBsvV","textWithIcon":"_3RcLU2MDzPtl_RR3SB2g47","containerFilter":"_1XFUzAhca6UjQUXXl4C2bR","spaceLeft":"_8J5l1mYim_zM0CNKAr823"};

/***/ }),

/***/ 61524:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeMenu":"WWe4KToHi9GTHFilq-GsV backgroundBorderColor","container":"_3Ig1X2CpRdxln0tBfFuzs8","loadingContainer":"wRPw54j3maLrgH2qY5FNO _3Ig1X2CpRdxln0tBfFuzs8","categories":"_3gONsDeMv_nq-sU7Li3y7a","categoriesList":"_2UXV5eFFzhuUB_yAI_P6W7","categoryItem":"_3uZcKFmu1Q7TOMGRVzXrJp","header":"qIhDQetEVCYUMdj4bdCN3","primaryColor":"_37MkYbCMjWTk8635JHCKR6"};

/***/ }),

/***/ 9474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"_2n863Ch04Xm6I8qOb9IjvQ"};

/***/ }),

/***/ 23568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Y2myTiF1rA1_xi6R74uFB","brandsContainer":"_101cBxD0_Oz4Bfa41WR_6y _3Y2myTiF1rA1_xi6R74uFB","category":"PMmYJcjwi0OVUNEI3wkNH categoriesBarItem","clearText":"_4PCTlb8gArXihRSnEAHca","darkText":"_3JaOd-lSXh8Z8Ocy4x9ZN-","active":"_1FOW7HfIed5hxwHYDkhbXo PMmYJcjwi0OVUNEI3wkNH categoriesBarItem categoriesBarItemActive textColor"};

/***/ })

}]);